import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_orders_for_revisionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { owner_lookup?: string, project_lookup?: string, type_id?: number, fulfillment_date?: string, created_date?: string, order_id?: number, take_amount?: number, max_created_date?: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, ProjectId?: number, VendorReference?: string, OrderClass?: { OrderTypeId?: number }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, LoadContainerSequence?: number, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number }[] } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { owner_lookup?: string, project_lookup?: string, type_id?: number, fulfillment_date?: string, created_date?: string, order_id?: number, take_amount?: number, max_created_date?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, ProjectId?: number, VendorReference?: string, OrderClass?: { OrderTypeId?: number }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, LoadContainerSequence?: number, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number }[] } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { owner_lookup?: string, project_lookup?: string, type_id?: number, fulfillment_date?: string, created_date?: string, order_id?: number, take_amount?: number, max_created_date?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, ProjectId?: number, VendorReference?: string, OrderClass?: { OrderTypeId?: number }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, LoadContainerId?: number, LoadContainerSequence?: number, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number }[] } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      owner_lookup?: string, project_lookup?: string, type_id?: number, fulfillment_date?: string, created_date?: string, order_id?: number, take_amount?: number, max_created_date?: string    }) {
      return false;
    }
}
